<script lang="ts">
    import {
        About,
        Contact,
        Experience,
        Footer,
        Home,
        Projects,
    } from "../components";
    import DrawerLayout from "./DrawerLayout.svelte";
    import ToolbarLayout from "./ToolbarLayout.svelte";
    import { onMount } from "svelte";
    import throttle from "lodash.throttle";
    import type { Positions } from "../models/positions";

    const links: string[] = [
        "Home",
        "About",
        "Experience",
        "Projects",
        "Contact",
    ];
    let scrollY: number;
    let innerWidth: number;
    let activeLink: string;
    $: computerScreen = innerWidth > 960;
    const handleScroll = throttle(setActiveLink, 200);

    onMount(setActiveLink);

    function getPosition(element: HTMLElement, offset: number): number {
        return Math.round(element.getBoundingClientRect().top + offset);
    }

    function createPositions(offset: number): Positions {
        let homePosition: number = getPosition(
            document.getElementById("home"),
            offset
        );
        if (!computerScreen) homePosition -= 56;
        const aboutPosition: number = getPosition(
            document.getElementById("about"),
            offset
        );
        const experiencePosition: number = getPosition(
            document.getElementById("experience"),
            offset
        );
        const projectsPosition: number = getPosition(
            document.getElementById("projects"),
            offset
        );
        const contactPosition: number = getPosition(
            document.getElementById("contact"),
            offset
        );

        return {
            home: homePosition,
            about: aboutPosition,
            experience: experiencePosition,
            projects: projectsPosition,
            contact: contactPosition,
        };
    }

    function setActiveLink(): void {
        const pageOffset: number = Math.round(scrollY);
        const positions: Positions = createPositions(pageOffset);

        if (positions.home <= pageOffset && positions.about > pageOffset) {
            activeLink = "Home";
        } else if (
            positions.about <= pageOffset &&
            positions.experience > pageOffset
        ) {
            activeLink = "About";
        } else if (
            positions.experience <= pageOffset &&
            positions.projects > pageOffset
        ) {
            activeLink = "Experience";
        } else if (
            positions.projects <= pageOffset &&
            positions.contact > pageOffset
        ) {
            activeLink = "Projects";
        } else {
            activeLink = "Contact";
        }
    }

    function linkClicked(event: CustomEvent): void {
        const link: string = event.detail;

        if (computerScreen) {
            document
                .getElementById(link.toLowerCase())
                .scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            window.scroll({
                behavior: "smooth",
                top:
                    document.getElementById(link.toLowerCase()).offsetTop -
                    (link === "Home" ? 56 : 0),
                left: 0,
            });
        }
    }
</script>

<svelte:window bind:scrollY bind:innerWidth on:scroll={handleScroll} />

{#if computerScreen}
    <DrawerLayout {activeLink} {links} on:linkClick={linkClicked} />
{:else}
    <ToolbarLayout {activeLink} {links} on:linkClick={linkClicked} />
{/if}
<div class={computerScreen ? "app-content" : "app-content-mobile"}>
    <div id="home">
        <Home {computerScreen} />
    </div>
    <div id="about">
        <About />
    </div>
    <div id="experience">
        <Experience />
    </div>
    <div id="projects">
        <Projects />
    </div>
    <div id="contact">
        <Contact {computerScreen} />
    </div>
    <Footer />
</div>
